const style ={
 inputbox :"appearance-none block w-full px-3 py-2 border boder-gray-300 rounded-md shadow-sm placeholder-gray-400  outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
}

export default style